export default {"src":"/_next/static/media/phone-icon.a09ce1a1.svg","height":46,"width":46};